import React from 'react'
import { withStyles } from '@material-ui/core'
import styles from './styles'
import { headerTemplate } from 'src/components/editor/components/custom-plugins/simple-box/header-template'
import { useSelector } from 'react-redux'

const Outline = ({ classes, pageUrl }) => {
  const course = useSelector(state => state.course.course)
  const { collection } = useSelector(state => state.collection)
  const courseSettings = useSelector(state => state.course.landingPageSettings)
  const collectionSettings = useSelector(
    state => state.collection.landingPageSettings,
  )

  // Then conditionally use the results
  const landingPageData =
    pageUrl === 'mini-course' ? courseSettings : collectionSettings

  // Get content data safely with null checks
  const getContentData = () => {
    if (!landingPageData?.sections?.[0]?.content)
      return { image: '', alignment: 'center' }
    var landingPageSection = landingPageData?.sections.find(
      x => x.type === 'Header',
    )
    return landingPageSection.content
  }

  // Process the image URL to add base URL if needed
  const processImageUrl = url => {
    if (!url) return ''
    return url.startsWith('https://')
      ? url
      : `https://cdn.minicoursegenerator.com/${url}`
  }

  const { image, alignment } = getContentData()
  const processedImage = processImageUrl(image)

  // Define styles based on alignment
  const getAlignmentStyles = () => ({
    textAlign: alignment,
    alignItems:
      alignment === 'center'
        ? 'center'
        : alignment === 'right'
        ? 'flex-end'
        : 'flex-start',
  })

  // Get background style
  const getBackgroundStyle = () => {
    if (!landingPageData) return null

    return {
      background: `linear-gradient(0deg, rgba(0, 0, 0, 0.3) 0%, rgba(0, 0, 0, 0.3) 100%), 
                  url(${processedImage}) 50% center / cover no-repeat lightgray`,
    }
  }

  return (
    <div className="editor-header-preview">
      <div className="editor-header-container" style={getBackgroundStyle()}>
        <div
          className="editor-header-content"
          style={landingPageData ? getAlignmentStyles() : null}
          dangerouslySetInnerHTML={{
            __html: headerTemplate(
              landingPageData,
              course,
              collection,
              pageUrl,
            ),
          }}
        />
      </div>
    </div>
  )
}

export default withStyles(styles)(Outline)
